import * as React from 'react';

import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export const useApiListener = (
    event: Event,
    listener: (params: any) => void,
    params: any[] = []
) => {
    React.useEffect(() => {
        apiProvider.on(event, listener);

        return () => {
            apiProvider.off(event, listener);
        };
    }, [...params, listener, event]);
};
